import React from "react";

function DashBoardStats({options}) {

  const {loading, admins, users} = options

  const currentMonth = new Date().getMonth() + 1;
  // Filter documents by the current month
  const filtered = users?.filter(doc => {
    const docMonth = new Date(doc.createdAt).getMonth() + 1;
    return docMonth === currentMonth;
  });

  const itUsers = admins?.filter(ad =>   ad.role.toLowerCase() === 'it');
  const backUsers = admins?.filter(ad =>   ad.role.toLowerCase() !== 'it');


  return (
    <div className="flex flex-wrap -mx-3">
      
      <div className="w-full max-w-full px-3 mb-6 sm:w-1/2 sm:flex-none xl:mb-0 xl:w-1/4">
      {loading ? <h3>loading...</h3> : ''}
        <div className="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border">
          <div className="flex-auto p-4">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    Total Clients
                  </p>
                  <h5 className="mb-0 font-bold">
                    {users.length}
                  </h5>
                </div>
              </div>
              <div className="px-3 text-right basis-1/3">
                <div className="inline-block w-12 h-12 text-center rounded-lg bg-gradient-to-tl from-primary to-primary-light">
                  <i className=" leading-none fa fa-users text-lg relative top-3.5 text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-full px-3 mb-6 sm:w-1/2 sm:flex-none xl:mb-0 xl:w-1/4">
        <div className="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border">
          <div className="flex-auto p-4">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    New Clients
                  </p>
                  <h5 className="mb-0 font-bold">
                    {filtered?.length}
                  </h5>
                </div>
              </div>
              <div className="px-3 text-right basis-1/3">
                <div className="inline-block w-12 h-12 text-center rounded-lg bg-gradient-to-tl from-primary to-primary-light">
                  <i className=" leading-none fa fa-users text-lg relative top-3.5 text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-full px-3 mb-6 sm:w-1/2 sm:flex-none xl:mb-0 xl:w-1/4">
        <div className="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border">
          <div className="flex-auto p-4">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    Total IT Users
                  </p>
                  <h5 className="mb-0 font-bold">
                    {itUsers?.length}
                    {/* <span className="leading-normal text-sm font-weight-bolder text-lime-500">+3%</span> */}
                  </h5>
                </div>
              </div>
              <div className="px-3 text-right basis-1/3">
                <div className="inline-block w-12 h-12 text-center rounded-lg bg-gradient-to-tl from-primary to-primary-light">
                  <i className=" leading-none fa fa-users text-lg relative top-3.5 text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full max-w-full px-3 sm:w-1/2 sm:flex-none xl:w-1/4">
        <div className="relative flex flex-col min-w-0 break-words bg-white shadow-soft-xl rounded-2xl bg-clip-border">
          <div className="flex-auto p-4">
            <div className="flex flex-row -mx-3">
              <div className="flex-none w-2/3 max-w-full px-3">
                <div>
                  <p className="mb-0 font-sans font-semibold leading-normal text-sm">
                    Back Office Users
                  </p>
                  <h5 className="mb-0 font-bold">
                    {backUsers?.length}
                    {/* <span className="leading-normal text-sm font-weight-bolder text-lime-500">+5%</span> */}
                  </h5>
                </div>
              </div>
              <div className="px-3 text-right basis-1/3">
                <div className="inline-block w-12 h-12 text-center rounded-lg bg-gradient-to-tl from-primary to-primary-light">
                  <i className=" leading-none fa fa-users text-lg relative top-3.5 text-white"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashBoardStats;
